import React from "react";

const NoSrpContact = () => (
  <section className="no-srp-contact">
    <h3>Still need help?</h3>
    <p>
      <a
        href="#tawk"
        onClick={() => {
          window && window.main && window.main.openTawkTo();
        }}
      >
        Chat
      </a>{" "}
      with one of the VenueScanner team!
    </p>
  </section>
);

export default NoSrpContact;
